var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsk = function SvgAsk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M1.667 10c0-3.928 0-5.892 1.22-7.113 1.221-1.22 3.185-1.22 7.113-1.22s5.893 0 7.113 1.22c1.22 1.222 1.22 3.185 1.22 7.113s0 5.893-1.22 7.113-3.185 1.22-7.113 1.22-5.892 0-7.113-1.22c-1.22-1.22-1.22-3.184-1.22-7.113Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8.438 7.396a1.563 1.563 0 1 1 2.356 1.346c-.396.234-.794.59-.794 1.05v1.042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 14.167a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
  })));
};
export default SvgAsk;